<template>
  <div class="contacts-success-modal">
    <div class="contacts-success-modal_content">
      <button
        @click="$emit('close')"
        type="button"
        class="contacts-success-modal_close"
        aria-label="Закрыть"
      >
        <svg viewBox="0 0 28 28" aria-hidden="true">
          <line x1="2" y1="2" x2="26" y2="26" />
          <line x1="26" y1="2" x2="2" y2="26" />
        </svg>
      </button>
      <h2 class="contacts-success-modal_title">
        Спасибо!
      </h2>
      <p class="contacts-success-modal_subtitle">
        Ваше сообщение принято.
      </p>
      <p class="contacts-success-modal_description">
        Мы свяжемся с Вами в ближайшее время...
      </p>
    </div>
    <!--
    <img
      class="contacts-success-modal_decor contacts-success-modal_decor&#45;&#45;sushi-plate"
      src="/contacts-success/sushi-plate.png"
      width="153"
      height="142"
      alt=""
      aria-hidden="true"
    >
    <img
      class="contacts-success-modal_decor contacts-success-modal_decor&#45;&#45;roll"
      src="/contacts-success/roll.png"
      width="93"
      height="93"
      alt=""
      aria-hidden="true"
    >
    <img
      class="contacts-success-modal_decor contacts-success-modal_decor&#45;&#45;side"
      src="/contacts-success/side.png"
      width="74"
      height="136"
      alt=""
      aria-hidden="true"
    >
    <img
      class="contacts-success-modal_decor contacts-success-modal_decor&#45;&#45;small-top"
      src="/contacts-success/small-top.png"
      width="58"
      height="55"
      alt=""
      aria-hidden="true"
    >
    <img
      class="contacts-success-modal_decor contacts-success-modal_decor&#45;&#45;chopsticks-top"
      src="/contacts-success/chopsticks.png"
      alt=""
      aria-hidden="true"
    >
    <img
      class="contacts-success-modal_decor contacts-success-modal_decor&#45;&#45;chopsticks-bottom"
      src="/contacts-success/chopsticks.png"
      alt=""
      aria-hidden="true"
    >-->
  </div>
</template>

<script>
export default {
  name: 'ContactsSuccess',
}
</script>

<style lang="less" scoped>
.contacts-success-modal {
  position: relative;
  width: 543px;
  max-width: 100%;
  padding: 27px 43px;
  box-sizing: border-box;

  &_content {
    position: relative;
    z-index: 2;
    background: #fff;
    border-radius: 30px;
    box-shadow: 0 16px 29px rgba(0, 0, 0, 0.09);
    padding: 80px 50px 70px;
    text-align: center;
    top: 50%;
    transform: translateY(-50%);
  }

  &_title {
    font-family: 'Aqum', Arial, sans-serif;
    font-size: 35px;
    margin: 0 0 20px;
  }

  &_subtitle {
    font-size: 25px;
    margin: 0 0 20px;
  }

  &_description {
    font-size: 14px;
    font-weight: 300;
    line-height: 1.4;
    margin: 0;
    opacity: 0.8;
  }

  &_close {
    position: absolute;
    top: 25px;
    right: 25px;
    z-index: 3;
    width: 49px;
    height: 49px;
    padding: 0;
    border: 0;
    cursor: pointer;
    background: #f3f3f3;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;

    svg {
      width: 14px;
      height: 14px;
      stroke: #000;
      stroke-width: 2;
      stroke-linecap: round;
      fill: none;
    }

    &:hover {
      background: #e6e6e6;
    }
  }

  &_decor {
    position: absolute;
    z-index: 1;
    pointer-events: none;
    user-select: none;
  }

  &_decor--sushi-plate {
    left: 27px;
    top: 146px;
    width: 153px;
    height: 142px;
  }

  &_decor--roll {
    right: 12px;
    top: 154px;
    width: 93px;
    height: 93px;
    border-radius: 26px;
  }

  &_decor--side {
    right: 40px;
    bottom: -34px;
    width: 74px;
    height: 136px;
  }

  &_decor--small-top {
    left: 104px;
    top: 0;
    width: 58px;
    height: 55px;
  }

  &_decor--chopsticks-top {
    left: 260px;
    top: 92px;
    transform: matrix(0.545, -0.839, 0.839, 0.545, 0, 0);
  }

  &_decor--chopsticks-bottom {
    left: 218px;
    top: 426px;
    transform: matrix(-0.439, 1.351, -1.351, -0.439, 0, 0);
  }
}

@media (max-width: 900px) and (min-width: 601px) {
  .contacts-success-modal {
    transform-origin: top center;
    transform: scale(0.85);
  }
}

@media (max-width: 600px) {
  .contacts-success-modal {
    width: 100%;
    padding: 20px;

    &_content {
      padding: 40px 24px 50px;
      border-radius: 20px;
    }

    &_title {
      font-size: 28px;
    }

    &_subtitle {
      font-size: 20px;
    }

    &_close {
      top: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
      border-radius: 12px;
    }

    &_decor {
      display: none;
    }
  }
}
</style>
